import {
  FieldOkConfig,
  FieldOkListViewComponent,
  FieldOkMultiselectListViewComponent,
  QueryFieldOkListViewComponent,
} from '@softline/dynamic';
import { ekorgListView } from './list-view/ekorg.list-view';

export const ekorgFieldOk: FieldOkConfig = {
  name: 'ekorg',
  type: 'default',
  priority: 0,
  defaultView: 'list',
  defaultDataView: 'list',
  template: '{{id}} - {{ekorg}}',
  autoQuery: true,
  views: [
    {
      name: 'list',
      component: FieldOkListViewComponent,
      title: 'Auswahl',
      config: {
        component: ekorgListView,
      },
    },
  ],
};
export const ekorgMultiselectFieldOk: FieldOkConfig = {
  name: 'ekorg',
  type: 'multi',
  priority: 0,
  defaultView: 'list',
  defaultDataView: 'list',
  template: '{{id}} - {{ekorg}}',
  autoQuery: true,
  views: [
    {
      name: 'list',
      component: FieldOkMultiselectListViewComponent,
      title: 'Auswahl',
      config: {
        component: ekorgListView,
      },
    },
  ],
};

export const ekorgQueryFieldOk: FieldOkConfig = {
  name: 'ekorg',
  type: 'query',
  priority: 0,
  defaultView: 'list',
  defaultDataView: 'list',
  template: '{{id}} - {{ekorg}}',
  autoQuery: true,
  views: [
    {
      name: 'list',
      component: QueryFieldOkListViewComponent,
      title: 'Auswahl',
      config: {
        component: ekorgListView,
      },
    },
  ],
};
